import { useSearchParams } from 'next/navigation';

export const useHasOrigin = (name: string): boolean => {
    const searchParams = useSearchParams();

    return searchParams.get('origin')?.toLowerCase() === name.toLowerCase();
};
